import React, { memo, useCallback } from 'react';
import { getPages } from "./getPages";
import { PageItem } from "./PageItem";
import { PageContainer } from "./PageContainer";
import { useIsMobileDimension } from "../hooks/useGetDimensionGroup";
export var Pagination = /*#__PURE__*/memo(function (_ref) {
  var total = _ref.total,
    current = _ref.current,
    onClick = _ref.onClick,
    limit = _ref.limit,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Pagination' : _ref$testName;
  var isMobile = useIsMobileDimension();
  var items = getPages(current, total, isMobile);
  var handleClick = useCallback(function (index) {
    onClick({
      offset: index * limit - limit,
      current: index
    });
  }, [limit, onClick]);
  return /*#__PURE__*/React.createElement(PageContainer, {
    current: current,
    setNearPage: handleClick,
    testName: testName,
    total: total
  }, items.map(function (_ref2) {
    var value = _ref2.value,
      isDots = _ref2.isDots;
    return /*#__PURE__*/React.createElement(PageItem, {
      isActive: current === value,
      isDots: isDots,
      key: value,
      onClick: handleClick,
      value: value
    });
  }));
});